// Çakışma (presence) bandı kopyası — TEK kaynak (Finar rev-A 18). Cümle ada ek getirmeyecek
// biçimde kurulur ("Ayşe'de da" / "Ali da" gibi ek uyumu sorunları olmasın): ad iki noktadan
// sonra yalın yazılır, birden çok kişide virgülle ayrılır.

export const PRESENCE_COPY = {
  leadOne: "Bu projede şu an başka bir kullanıcı da çalışıyor:",
  leadMany: "Bu projede şu an başka kullanıcılar da çalışıyor:",
  tail: "— kaydederken çakışma olabilir.",
} as const;

export interface PresenceBannerParts {
  lead: string;
  names: string;
  tail: string;
}

/** Bant parçaları (ad kalın yazılabilsin diye ayrı); ad yoksa `null` (bant render edilmez). */
export function presenceBannerParts(names: readonly string[]): PresenceBannerParts | null {
  const clean = names.map((n) => n.trim()).filter((n) => n !== "");
  if (clean.length === 0) return null;
  return {
    lead: clean.length === 1 ? PRESENCE_COPY.leadOne : PRESENCE_COPY.leadMany,
    names: clean.join(", "),
    tail: PRESENCE_COPY.tail,
  };
}

/** Düz metin cümle (test + erişilebilir ad için). */
export function presenceBannerText(names: readonly string[]): string | null {
  const p = presenceBannerParts(names);
  return p ? `${p.lead} ${p.names} ${p.tail}` : null;
}
